import { useDispatch, useSelector } from "react-redux";
import { setIsAllFiltersOpen } from "../../redux/searchbarSlice";
import useWindowWidth from "../../hooks/useWindowWidth";
import { setNewFilters } from "../../redux/filtersSlice";
import { useTranslation } from "react-i18next";

const AllFilters = () => {

    const {t} = useTranslation();


    // Gestisco la chiusura del componente
    const dispatch = useDispatch();
    const { isFixed, isAllFiltersOpen } = useSelector(state => state.searchbar);

    // Gestisco il layout fixed del componente
    const windowWidth = useWindowWidth();

    // Gestisco l'impostazione iniziale dei filtri già impostati
    const { filtersObject } = useSelector(state => state.filters);

    // Gestisco gli input
    const handleInput = (event) => {
        const { id, value, checked } = event.target;
        let fixedId = id;
        let fixedValue = value;
        if (id.slice(0, 12) === 'activityType') fixedId = 'activityType';
        if (id.slice(0, 6) === 'region') fixedId = 'region';
        if (id.slice(0, 10) === 'groupModel') fixedId = 'groupModel';
        if (id.slice(0, 15) === 'availablePeriod') fixedId = 'availablePeriod';
        if (id.slice(0, 15) === 'difficultyLevel') fixedId = 'difficultyLevel';
        if (id.slice(0, 5) === 'other') fixedId = 'other';
        let oldArray = filtersObject[fixedId] || [];
        if (checked) {
            fixedValue = [...oldArray, fixedValue]
        } else {
            fixedValue = oldArray.filter(element => element !== fixedValue)
        }
        console.log({ fixedId })
        console.log({ fixedValue })
        dispatch(setNewFilters({ [fixedId]: fixedValue }))
    }

    return (
        <div className={`${windowWidth < 768 ? 'fixed inset-0 overflow-y-auto pb-8' : 'w-[600px] mt-2 rounded-xl py-8'} bg-[#f7f7f8] w-full z-10 flex flex-col items-center gap-2`}>
            {/* Close in mobile */}
            <div className='text-black w-fit rounded-xl cursor-pointer p-2 self-start md:hidden' onClick={() => dispatch(setIsAllFiltersOpen(false))}>
                <i className="fi fi-rr-circle-xmark text-2xl"></i>
            </div>

            {/* Filters list */}
            <div className="flex flex-col gap-8">

                {/* row 1 */}
                <div className="flex flex-col md:flex-row gap-8">
                    {/* Tipo di attività */}
                    <div className="flex flex-col gap-1 pb-8 border-b md:pr-8 md:border-0 md:border-r">
                        <h3 className="text-[#225424]">{t('poolBar.AllFilters.activityTypeTitle')}</h3>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Acqua" id="activityType1" value="Acqua" checked={filtersObject.activityType && filtersObject.activityType.includes('Acqua')} onChange={handleInput} />
                            <label htmlFor="Acqua">{t('poolBar.AllFilters.water')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Aria" id="activityType2" value="Aria" checked={filtersObject.activityType && filtersObject.activityType.includes('Aria')} onChange={handleInput} />
                            <label htmlFor="Aria">{t('poolBar.AllFilters.air')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Terra" id="activityType3" value="Terra" checked={filtersObject.activityType && filtersObject.activityType.includes('Terra')} onChange={handleInput} />
                            <label htmlFor="Terra">{t('poolBar.AllFilters.land')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Neve" id="activityType4" value="Neve" checked={filtersObject.activityType && filtersObject.activityType.includes('Neve')} onChange={handleInput} />
                            <label htmlFor="Neve">{t('poolBar.AllFilters.snow')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Best View" id="activityType5" value="Best Views" checked={filtersObject.activityType && filtersObject.activityType.includes('Best Views')} onChange={handleInput} />
                            <label htmlFor="Best View">{t('poolBar.AllFilters.bestViews')}</label>
                        </div>
                    </div>

                    {/* Regione */}

                    <div className="flex flex-col gap-1 pb-8 border-b md:pr-8 md:border-0 md:border-r">
                        <h3 className="text-[#225424]">{t('poolBar.AllFilters.regionTitle')}</h3>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Ascona-Locarno" id="region1" value='Ascona-Locarno' checked={filtersObject.region && filtersObject.region.includes('Ascona-Locarno')} onChange={handleInput} />
                            <label htmlFor="Ascona-Locarno">{t('poolBar.AllFilters.asconaLocarno')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Bellinzona e Valli" id="region2" value='Bellinzona e Valli' checked={filtersObject.region && filtersObject.region.includes('Bellinzona e Valli')} onChange={handleInput} />
                            <label htmlFor="Bellinzona e Valli">{t('poolBar.AllFilters.bellinzonaValli')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Luganese" id="region4" value='Luganese' checked={filtersObject.region && filtersObject.region.includes('Luganese')} onChange={handleInput} />
                            <label htmlFor="Luganese">{t('poolBar.AllFilters.luganese')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Mendrisiotto" id="region3" value='Mendrisiotto' checked={filtersObject.region && filtersObject.region.includes('Mendrisiotto')} onChange={handleInput} />
                            <label htmlFor="Mendrisiotto">{t('poolBar.AllFilters.mendrisiotto')}</label>
                        </div>
                    </div>

                    {/* Tipo di gruppo */}
                    <div className="flex flex-col gap-1 pb-8 border-b md:border-0">
                        <h3 className="text-[#225424]">{t('poolBar.AllFilters.groupModelTitle')}</h3>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Da soli" id="groupModel1" value="Da soli" checked={filtersObject.groupModel && filtersObject.groupModel.includes("Da soli") ? true : false} onChange={handleInput} />
                            <label htmlFor="Da soli">{t('poolBar.AllFilters.alone')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="In coppia" id="groupModel2" value="In coppia" checked={filtersObject.groupModel && filtersObject.groupModel.includes("In coppia") ? true : false} onChange={handleInput} />
                            <label htmlFor="In coppia">{t('poolBar.AllFilters.couple')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Tra amici" id="groupModel3" value="Tra amici" checked={filtersObject.groupModel && filtersObject.groupModel.includes("Tra amici") ? true : false} onChange={handleInput} />
                            <label htmlFor="Tra amici">{t('poolBar.AllFilters.friends')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="In famiglia" id="groupModel4" value="In famiglia" checked={filtersObject.groupModel && filtersObject.groupModel.includes("In famiglia") ? true : false} onChange={handleInput} />
                            <label htmlFor="In famiglia">{t('poolBar.AllFilters.family')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input type="checkbox" name="Per i più piccoli" id="groupModel5" value="Per i più piccoli" checked={filtersObject.groupModel && filtersObject.groupModel.includes("Per i più piccoli") ? true : false} onChange={handleInput} />
                            <label htmlFor="Per i più piccoli">{t('poolBar.AllFilters.kids')}</label>
                        </div>
                    </div>
                </div>

                {/* row 2 */}

                <div className="flex flex-col md:flex-row gap-8">
                    {/* Periodo */}
                    <div className="flex flex-col md:flex-row gap-0 pb-8 border-b md:gap-8 md:pr-8 md:border-0 md:border-r">
                        <div>
                            <h3 className="text-[#225424]">{t('poolBar.AllFilters.periodTitle')}</h3>
                            <div className="flex gap-2">
                                <input id="availablePeriod1" type="checkbox" name="Gennaio" value="Gennaio" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Gennaio") ? true : false} />
                                <label htmlFor="Gennaio">{t('poolBar.AllFilters.january')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod2" type="checkbox" name="Febbraio" value="Febbraio" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Febbraio") ? true : false} />
                                <label htmlFor="Febbraio">{t('poolBar.AllFilters.febrary')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod3" type="checkbox" name="Marzo" value="Marzo" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Marzo") ? true : false} />
                                <label htmlFor="Marzo">{t('poolBar.AllFilters.march')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod4" type="checkbox" name="Aprile" value="Aprile" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Aprile") ? true : false} />
                                <label htmlFor="Aprile">{t('poolBar.AllFilters.april')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod5" type="checkbox" name="Maggio" value="Maggio" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Maggio") ? true : false} />
                                <label htmlFor="Maggio">{t('poolBar.AllFilters.may')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod6" type="checkbox" name="Giugno" value="Giugno" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Giugno") ? true : false} />
                                <label htmlFor="Giugno">{t('poolBar.AllFilters.june')}</label>
                            </div>
                        </div>
                        <div className="md:mt-8">
                            <div className="flex gap-2">
                                <input id="availablePeriod7" type="checkbox" name="Luglio" value="Luglio" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Luglio") ? true : false} />
                                <label htmlFor="Luglio">{t('poolBar.AllFilters.july')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod8" type="checkbox" name="Agosto" value="Agosto" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Agosto") ? true : false} />
                                <label htmlFor="Agosto">{t('poolBar.AllFilters.august')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod9" type="checkbox" name="Settembre" value="Settembre" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Settembre") ? true : false} />
                                <label htmlFor="Settembre">{t('poolBar.AllFilters.september')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod10" type="checkbox" name="Ottobre" value="Ottobre" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Ottobre") ? true : false} />
                                <label htmlFor="Ottobre">{t('poolBar.AllFilters.october')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod11" type="checkbox" name="Novembre" value="Novembre" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Novembre") ? true : false} />
                                <label htmlFor="Novembre">{t('poolBar.AllFilters.november')}</label>
                            </div>
                            <div className="flex gap-2">
                                <input id="availablePeriod12" type="checkbox" name="Dicembre" value="Dicembre" onChange={handleInput} checked={filtersObject.availablePeriod && filtersObject.availablePeriod.includes("Dicembre") ? true : false} />
                                <label htmlFor="Dicembre">{t('poolBar.AllFilters.december')}</label>
                            </div>
                        </div>
                    </div>

                    {/* Livello di difficoltà */}
                    <div className="flex flex-col gap-1 pb-8 border-b md:pr-8 md:border-0 md:border-r">
                        <h3 className="text-[#225424]">{t('poolBar.AllFilters.difficultyLevelTitle')}</h3>
                        <div className="flex gap-2">
                            <input id='difficultyLevel1' type="checkbox" name="Facile" value="Facile" onChange={handleInput} checked={filtersObject.difficultyLevel && filtersObject.difficultyLevel.includes("Facile") ? true : false} />
                            <label htmlFor="Facile">{t('poolBar.AllFilters.easy')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id='difficultyLevel2' type="checkbox" name="Medio" value="Medio" onChange={handleInput} checked={filtersObject.difficultyLevel && filtersObject.difficultyLevel.includes("Medio") ? true : false} />
                            <label htmlFor="Medio">{t('poolBar.AllFilters.medium')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id='difficultyLevel3' type="checkbox" name="Difficile" value="Difficile" onChange={handleInput} checked={filtersObject.difficultyLevel && filtersObject.difficultyLevel.includes("Difficile") ? true : false} />
                            <label htmlFor="Difficile">{t('poolBar.AllFilters.hard')}</label>
                        </div>
                    </div>

                    {/* Altri */}
                    <div className="flex flex-col gap-1">
                        <h3 className="text-[#225424]">{t('poolBar.AllFilters.othersTitle')}</h3>
                        <div className="flex gap-2">
                            <input id="other1" type="checkbox" name="Dog friendly" value="Dog friendly" onChange={handleInput} checked={filtersObject.other && filtersObject.other.includes("Dog friendly") ? true : false} />
                            <label htmlFor="Dog friendly">{t('poolBar.AllFilters.dogFriendly')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id="other2" type="checkbox" name="Laghetti alpini" value="Laghetti alpini" onChange={handleInput} checked={filtersObject.other && filtersObject.other.includes("Laghetti alpini") ? true : false} />
                            <label htmlFor="Laghetti alpini">{t('poolBar.AllFilters.alpineLakes')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id="other3" type="checkbox" name="Accessibile" value="Accessibile" onChange={handleInput} checked={filtersObject.other && filtersObject.other.includes("Accessibile") ? true : false} />
                            <label htmlFor="Accessibile">{t('poolBar.AllFilters.accessible')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id="other4" type="checkbox" name="isMonthAdviced" value="isMonthAdviced" onChange={handleInput} checked={filtersObject.other && filtersObject.other.includes("isMonthAdviced") ? true : false} />
                            <label htmlFor="isMonthAdviced">{t('poolBar.AllFilters.monthAdvices')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id="other4" type="checkbox" name="isForInstagrammers" value="isForInstagrammers" onChange={handleInput} checked={filtersObject.other && filtersObject.other.includes("isForInstagrammers") ? true : false} />
                            <label htmlFor="isForInstagrammers">{t('poolBar.AllFilters.forInstagrammers')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id="other5" type="checkbox" name="MTB" value="MTB" onChange={handleInput} checked={filtersObject.other && filtersObject.other.includes("MTB") ? true : false} />
                            <label htmlFor="MTB">{t('poolBar.AllFilters.mountainBike')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id="other6" type="checkbox" name="Cascate, fiumi e pozze" value="Cascate, fiumi e pozze" onChange={handleInput} checked={filtersObject.other && filtersObject.other.includes("Cascate, fiumi e pozze") ? true : false} />
                            <label htmlFor="Cascate, fiumi e pozze">{t('poolBar.AllFilters.waterPlace')}</label>
                        </div>
                        <div className="flex gap-2">
                            <input id="other7" type="checkbox" name="Griglia fissa" value="Griglia fissa" onChange={handleInput} checked={filtersObject.other && filtersObject.other.includes("Griglia fissa") ? true : false} />
                            <label htmlFor="Griglia fissa">{t('poolBar.AllFilters.fixedGrill')}</label>
                        </div>
                        
                    </div>

                </div>

                {/* Close in desktop */}
                <div className="hidden md:flex gap-2 cursor-pointer" onClick={() => dispatch(setIsAllFiltersOpen(false))}>
                    <i className="fi fi-rr-angle-small-up text-2xl"></i>
                    <div>Chiudi filtri</div>
                </div>
            </div>

        </div >
    )
}

export default AllFilters;